import { useEffect } from 'react';
import { Axios, useAPIMethods } from '../../apis';

const BASIC_API_URL = process.env.GATSBY_BASE_API_URL;
// const BASIC_PROXY_URL = process.env.GATSBY_BASE_PROXY_URL;

const useProvideAPI = () => {
  // const DEBUG_ENABLED = process.env.GATSBY_USE_DEBUG === 'true';
  const url = BASIC_API_URL;
  // if (DEBUG_ENABLED) {
  //   url = BASIC_PROXY_URL + BASIC_API_URL;
  // }

  const axios = new Axios({
    baseURL: url,
    timeout: 60,
    recallOn: false,
    recallTimes: 3,
    shouldReturnCode: true,
  });

  const api = useAPIMethods({ axios });

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const retrySync = localStorage.getItem('sync_member_retry');
      if (retrySync) {
        try {
          const { token, customerNo, timestamp } = JSON.parse(retrySync);
          if (token && customerNo) {
            if (timestamp && Date.now() - timestamp < 5000) return;
            api.syncMember({ token, customerNo }).then((res) => {
              if (res) {
                localStorage.removeItem('sync_member_retry');
              }
            });
          }
        } catch (e) {
          localStorage.removeItem('sync_member_retry');
        }
      }
    }
  }, []);

  return Object.assign({}, api);
};

export default useProvideAPI;
